import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { TextAlpha } from '@yonderland/andes-react';
export const ColorOutOfStockMessageAlpha = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return _jsx(TextAlpha, { strong: true, children: t('product.colorNotAvailable') });
};
